import { Button, ProtectedComponent, TextInput } from "../../components";
import OfficePatientFilterSelect, { OfficePatientFilterType } from "./OfficePatientFilterSelect";
import { AuthPermission } from "../../services/auth.service";

interface OfficePatientsActionsProps {
  selectedFilter: OfficePatientFilterType;
  onFilter: (value: OfficePatientFilterType) => void;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchQuery: string;
  onClickDownloadCSV: () => void;
  showInviteActions: boolean;
  allowInviteActions: boolean;
  onClickInvitePatient: () => void;
  onClickBulkInvite: () => void;
}

const OfficePatientsActions = ({
  selectedFilter,
  onFilter,
  onSearch,
  searchQuery,
  onClickDownloadCSV,
  showInviteActions,
  allowInviteActions,
  onClickInvitePatient,
  onClickBulkInvite,
}: OfficePatientsActionsProps) => {
  const inviteButtonAdditionalClassNames = `whitespace-nowrap w-auto mt-3 md:mt-0 ${allowInviteActions ? "opacity-30" : ""}`;
  return (
    <div className="block md:flex md:justify-end w-full items-center lg:w-3/4">
      <OfficePatientFilterSelect value={selectedFilter} onChange={onFilter} />
      <div className="flex items-center">
        <div className="relative w-full">
          <TextInput value={searchQuery} onChangeFunc={onSearch} placeholder={"Search patients"} extraInputClass="w-full" isSearchInput={true} />
        </div>
      </div>
      <Button text="Download CSV" onClick={onClickDownloadCSV} className="whitespace-nowrap mt-3 md:ml-3 md:mt-0" />
      {showInviteActions && (
        <ProtectedComponent requiredPermission={[AuthPermission.User]}>
          <div className="block md:flex md:justify-end items-center space-y-2 md:space-y-0 md:gap-x-2 ml-0 md:ml-5">
            <span className="mr-2 font-medium text-center hidden md:inline-block">or</span>
            <Button text="Invite Patient" onClick={onClickInvitePatient} className={inviteButtonAdditionalClassNames} />
            <Button text="Bulk Invite" className={inviteButtonAdditionalClassNames} onClick={onClickBulkInvite} />
          </div>
        </ProtectedComponent>
      )}
    </div>
  );
};

export default OfficePatientsActions;
